/**
 * Class promotional items & gifts in product page.
 * @author Rémi Fortier <r.fortier@novatize.com>
 */

class ProductPromotions {
  constructor() {
    this.settings = JSON.parse(document.getElementById('product-promotions-settings').innerText);
    this.selectedVariant = document.getElementById("selected-variant-id").value;
    this.variantSelector = document.querySelector('.variants-container');
    this.debugMode = false;

    if (this.variantSelector) {
      this.addVariantSelectorListener(this.variantSelector)
    }

    this.checkPromoAndAddGifts.call(this);

  }

  checkPromoAndAddGifts() {
    // resets gift list
    this.insertGiftFormInput();
    this.promotionalItem = this.findPromotionalItem();

    if (!this.promotionalItem) return;

    this.giftsItem = this.findGiftsItems(this.promotionalItem);

    if (this.debugMode) {
      console.log("Promotions:", this.promotionalItem),
      console.log("Gifts:", this.giftsItem)
    }

    if (this.giftsItem.length) this.insertGiftFormInput(this.giftsItem);
  }

  addVariantSelectorListener(selector) {
    selector.addEventListener("change", this.setProductVariantId.bind(this));
  }

  setProductVariantId() {
    setTimeout(() => {
      const selectedVariant = document.getElementById("selected-variant-id").value
      this.selectedVariant = selectedVariant;
      this.checkPromoAndAddGifts()
    }, 250)
  }

  findPromotionalItem() {
    return this.settings.promotions.filter( promotion => {
      let product_variant_ids = promotion.custom_variant_id.split(',');
      product_variant_ids = product_variant_ids.filter(variant_id=>!!variant_id);
      product_variant_ids = product_variant_ids.map(variant_id=>variant_id.trim());
      
      if(!!product_variant_ids.length) {
        return !!product_variant_ids.includes(this.selectedVariant)
      } else {
        return promotion.first_available_variant_id === this.selectedVariant
      }
    })[0];
  }

  findGiftsItems(product) {
    let gifts = [];

    product.gifts.forEach( gift => {
      if (gift.gift && (gift.custom_variant_id || gift.variant_id) ) {
        gifts.push( gift.custom_variant_id ? gift.custom_variant_id : gift.variant_id )
      }
    })

    return gifts
  }

  /**
 * Adds the gift variant id to an hidden input present in the product form
 * @param {array} gifts list of promotionnal items to add
 */
  insertGiftFormInput(gifts) {
    const giftsInput = document.querySelector('#gifts-variants-id');

    if (gifts) {
      giftsInput.value = gifts.join(',')
    } else {
      giftsInput.value = ''
    }
  }
  
}

const productPromotions = new ProductPromotions()